module.exports = __webpack_public_path__ + "img/full_map_ca.a193267e.png";